import { render } from "./LaboratoryForm.vue?vue&type=template&id=0f33526a"
import script from "./LaboratoryForm.vue?vue&type=script&lang=js"
export * from "./LaboratoryForm.vue?vue&type=script&lang=js"

import "./LaboratoryForm.vue?vue&type=style&index=0&id=0f33526a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__